var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500px",
    height: "500px",
    viewBox: "0 0 200 200",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1007"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2773",
    cx: 100,
    cy: 113,
    r: 40,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2774",
    stopOpacity: 0.5,
    stopColor: "#fff4f3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2775",
    stopOpacity: 0,
    stopColor: "#f3d4cf",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2777",
    cx: 100,
    cy: 57,
    r: 36,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2778",
    stopOpacity: 0.5,
    stopColor: "#fff4f3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2779",
    stopOpacity: 0,
    stopColor: "#f3d4cf",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2815",
    cx: -558.588,
    cy: -490.918,
    r: 84.646,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 140.5478 120.3577)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2816",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2817",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2819",
    cx: -565.337,
    cy: -492.691,
    r: 84.644,
    gradientTransform: "matrix(0.0991 8.856325e-004 -0.0011 0.0991 130.3774 136.3533)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2820",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2821",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient2825",
    x1: 122.283,
    y1: 93.047,
    x2: 123.61,
    y2: 91.466,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2826",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2827",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient2829",
    x1: 127,
    y1: 85,
    x2: 125,
    y2: 87,
    gradientTransform: "matrix(1 0 0 1 -50 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2830",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2831",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient2833",
    x1: 130,
    y1: 81,
    x2: 126,
    y2: 85,
    gradientTransform: "matrix(1 0 0 1 -50 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2834",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2835",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2838",
    cx: -578.76,
    cy: -490.73,
    r: 84.646,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 192.4794 119.8404)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2839",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2840",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2842",
    cx: -584.778,
    cy: -487.329,
    r: 84.644,
    gradientTransform: "matrix(0.0991 8.856325e-004 -0.0011 0.0991 182.3104 135.839)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2843",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2844",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient2848",
    x1: 120.284,
    y1: 93.047,
    x2: 121.611,
    y2: 91.467,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2849",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2850",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient2852",
    x1: 127,
    y1: 85,
    x2: 125,
    y2: 87,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2853",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2854",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient2856",
    x1: 130,
    y1: 81,
    x2: 126,
    y2: 85,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2857",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2858",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient2902",
    x1: 100,
    y1: 141,
    x2: 100,
    y2: 138,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2903",
    stopOpacity: 1,
    stopColor: "#ebc3bd",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2904",
    stopOpacity: 1,
    stopColor: "#e4b3ab",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3003",
    x1: 99.98,
    y1: 171.27,
    x2: 99.98,
    y2: 136.351,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3004",
    stopOpacity: 0.8,
    stopColor: "#e4b3ab",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3005",
    stopOpacity: 1,
    stopColor: "#c5796d",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3289",
    cx: 129.05,
    cy: 85.956,
    r: 15.117,
    gradientTransform: "matrix(-0.9945 0.1042 0.1042 0.9945 192.8274 -12.4637)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3290",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3291",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3292",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3293",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3294",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3296",
    cx: 129.049,
    cy: 85.956,
    r: 15.117,
    gradientTransform: "matrix(0.9945 0.1042 -0.1042 0.9945 7.1735 -12.4637)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3297",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3298",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3299",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3300",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3301",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3303",
    cx: 129.05,
    cy: 85.956,
    r: 15.117,
    gradientTransform: "matrix(-0.9945 0.1042 0.1042 0.9945 192.8274 -12.4637)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3304",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3305",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3306",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3307",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3308",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3312",
    cx: 121.786,
    cy: 84.496,
    fx: 133.039,
    fy: 84.527,
    r: 16.003,
    gradientTransform: "matrix(0.9998 0.0208 0.0166 -0.7998 -44.9524 149.5433)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3313",
    stopOpacity: 1,
    stopColor: "#e4b3ab",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3314",
    stopOpacity: 0.3,
    stopColor: "#e4b3ab",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3315",
    stopOpacity: 0,
    stopColor: "#f3d4cf",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3317",
    cx: 69.124,
    cy: 107.529,
    r: 29.525,
    gradientTransform: "matrix(1.0336 0 0 1.0336 -1.6792 1.7282)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3318",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3319",
    stopOpacity: 0.3,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3323",
    cx: 129.049,
    cy: 85.956,
    r: 15.117,
    gradientTransform: "matrix(0.9945 0.1042 -0.1042 0.9945 7.1735 -12.4637)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3324",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3325",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3326",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3327",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3328",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3332",
    cx: 121.786,
    cy: 84.496,
    fx: 133.039,
    fy: 84.527,
    r: 16.003,
    gradientTransform: "matrix(-0.9998 0.0208 -0.0166 -0.7998 244.9525 149.5433)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3333",
    stopOpacity: 1,
    stopColor: "#e4b3ab",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3334",
    stopOpacity: 0.3,
    stopColor: "#e4b3ab",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3335",
    stopOpacity: 0,
    stopColor: "#f3d4cf",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3337",
    cx: 69.124,
    cy: 107.529,
    r: 29.525,
    gradientTransform: "matrix(-1.0336 0 0 1.0336 201.6792 1.7282)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3338",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3339",
    stopOpacity: 0.3,
    stopColor: "#000000",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2764",
    d: "M225 225H-25V-25h250V225z",
    fill: "#ecf0f1",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2974",
    d: "M41.279 215.266c-0.033-0.044-0.063-0.094-0.095-0.14 3.872-1.418 107.984 7.4 115.031 6.323 -0.001 0.108-0.007 0.217-0.007 0.325 0.282-0.064 0.24-0.075 0.254-0.359 0.259-0.032 1.051-0.167 0.027-0.457 3.485-63.467 43.554-53.333 20.529-111.343 -5.448-13.536-5.042-26.26-6.357-42.117 -1.84 1.797-1.238 11.106-3.489 28.325 17.078 53.526 2.414 51.246-11.503 76.872 -4.604 8.467-8.295 17.095-9.091 26.65 -22.673-39.208-16.05-38.328-6.981-62.078 -1.56 2.201-7.898 6.916-13.709 8.025 14.211-10.797 22.683-10.831 22.98-76.708 -13.031-6.03-24.886-17.239-32.2-29.8 -9.476 19.65-26.281 27.875-47.75 31.14 -5.35 2.72-10.92 5-16.55 7.08 -0.476 27.679 6.753 46.579 21.26 66.64 -5.091-3.645-10.294-9.649-13.96-14.758 4.4 8.811 10.944 16.104 9.16 31.867 -1.972 17.313-18.629 29.105-18.629 51.372 -16.264-25.388-21.752-14.633-17.979-42.312 -6.177-10.806-9.18-18.142-11.68-25.979 -0.605-0.005-1.578 0.138-2.133 0.204C11.333 170.695 21.465 190.498 41.279 215.266z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2975",
    d: "M142.489 227.847h-90V97.24h90V227.847z",
    fill: "#0c080c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2976",
    d: "M156.49 220.958c3.485-63.467 43.554-53.333 20.529-111.343 -4.317-10.726-4.958-20.946-5.692-32.615 -0.213 0-0.427 0-0.641 0 0.342 11.384 0.54 21.512 3.883 31.266 20.946 61.4-17.667 48.849-18.343 112.635 -4.423-0.602-111.114-7.244-115.042-5.775 -14.061-20.667-24.449-40.831-22.283-63.372 -0.668-0.594-1.228-1.297-1.759-2.028 -4.286 23.862 5.757 42.566 24.137 65.541 -0.033-0.044-0.063-0.094-0.095-0.14 3.872-1.418 107.984 7.4 115.031 6.323 -0.001 0.108-0.007 0.217-0.007 0.325 0.282-0.064 0.24-0.075 0.254-0.359C156.722 221.383 157.514 221.248 156.49 220.958z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2780",
    d: "M190.858 199.866c-6.008-10.158-13.474-11.973-19.628-13.936 -6.323-2.016-19.346-3.178-26.449-4.6 -6.86-1.373-23.153-5.789-23.339-13.488 -0.192-8.066 4.291-40.09 4.291-40.09H74.005c0 0 4.487 32.023 4.294 40.09 -0.184 7.699-16.48 12.115-23.341 13.488 -7.104 1.422-20.125 2.584-26.448 4.6 -6.156 1.963-13.624 3.777-19.632 13.936 -3.644 6.16-6.008 16.133-6.008 27.133h194C196.869 215.999 194.509 206.026 190.858 199.866z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2781",
    d: "M121.442 167.843c2.495 10.929 18.165 13.698 26.293 15.325 21.909 4.379 33.772 5.134 42.297 19.539 2.903 4.916 5.459 15.864 5.962 24.153 1.835 0.291 0.531-17.432-5.136-26.994 -9.742-16.472-29.089-15.135-46.077-18.535C137.921 179.958 121.628 175.542 121.442 167.843L121.442 167.843zM78.558 167.843c-0.186 7.699-16.479 12.115-23.339 13.488 -16.988 3.4-36.335 2.063-46.077 18.535 -5.667 9.563-6.971 27.285-5.136 26.994 0.503-8.289 3.059-19.237 5.962-24.153 8.524-14.405 20.388-15.16 42.297-19.539C60.393 181.541 76.063 178.771 78.558 167.843L78.558 167.843z",
    fill: "#fff4f3",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2782",
    d: "M51.206 189.513c0 0 28.641 0.299 33.473 1.885 2.314 0.758 8.372 5.633 8.372 5.633s-6.556-3.17-8.658-3.758C79.51 191.909 51.206 189.513 51.206 189.513zM99.795 199.999c2.053-0.041 7.887-3.799 7.887-3.799s-5.574 2.059-7.342 2.16c-1.491 0.086-6.366-1.238-6.366-1.238S98.112 200.032 99.795 199.999zM117.008 192.757c6.75-1.818 29.786-3.23 29.786-3.23s-23.791-0.516-30.51 1.725c-2.252 0.752-7.562 5.16-7.562 5.16S114.786 193.354 117.008 192.757z",
    fill: "#e4b3ab",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2783",
    d: "M190.858 199.866c-9.741-16.471-29.122-15.142-46.077-18.535 -6.86-1.373-23.153-5.789-23.339-13.488 -0.192-8.066 4.291-40.09 4.291-40.09H74.005c0 0 4.487 32.023 4.294 40.09 -0.184 7.699-16.48 12.115-23.341 13.488 -7.104 1.422-20.125 2.584-26.448 4.6 -6.156 1.963-13.624 3.777-19.632 13.936 -3.644 6.16-6.008 16.133-6.008 27.133h194C196.869 215.999 194.509 206.026 190.858 199.866z",
    fill: "none",
    stroke: "#c5796d",
    strokeWidth: 1.5,
    opacity: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3002",
    d: "M100.002 171.005c10.695 0 16.372-2.606 20.836-5.726 0.384-8.456 2.755-26.607 3.782-34.206 -14.799-1.759-34.763-1.747-49.5 0.032 1.023 7.564 3.362 25.461 3.771 33.979C83.4 168.289 89.086 171.005 100.002 171.005z",
    fill: "url(#SvgjsLinearGradient3003)",
    opacity: 1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2995",
    d: "M30.001 232.556c2.241-18.245 0.078-43.233-0.092-47.774 1.455-3.036 4.17-3.09 7.037-1.8 0.922-1.402 2.811-2.107 5.343-1.056v-0.15c1.067-0.882 1.788-2.667 4.068-1.426 1.595-1.728 3.824-1.542 5.95-0.554h0.071l0.076-0.058c0.684-1.977 2.147-2.091 4.035-1.15v-0.162c0.622-1.629 2.972-1.361 4.711-0.952 12.235 9.88 29.726 21.169 42.436 28.4 0.077-0.057 18.103-13.333 18.103-13.429 1.525-0.984 11.141-7.709 18.003-13.162 1.783-0.63 4.413-0.996 6.045-0.132 1-0.253 1.905-0.696 3.902 1.301l0.049 0.098c1.931-0.992 5.176-1.134 6.063 1.528 1-0.173 3.564-1.396 4.444 0.437l0.142 0.097c1.796-0.519 3.157-0.086 3.735 0.5l0.054-0.06c1.837-0.689 4.266-0.898 5.134 0.906 0.349 0.77 0.219 1.181 0.18 2.072 -4.185 26.167-3.409 37.476-1.301 46.729C145.421 233.437 31.001 232.556 30.001 232.556z",
    fill: "#09aac5",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2996",
    d: "M147.809 184.721c-1.866-2.231-3.948-1.846-4.735-1.369 -0.92-2.239-5.886-1.676-7.239-0.997 1.35-1.022 2.674-2.045 3.908-3.025 1.783-0.63 4.413-0.996 6.045-0.132 1-0.253 1.905-0.696 3.902 1.301l0.049 0.098c1.931-0.992 5.176-1.134 6.063 1.528 1-0.173 3.564-1.396 4.444 0.437l0.142 0.097c1.796-0.519 3.157-0.086 3.735 0.5l0.054-0.06c1.837-0.689 4.266-0.898 5.134 0.906 0.349 0.77 0.219 1.181 0.18 2.072 -0.081 1.594-0.201 2.068-0.261 3.546 -0.736-1.415-4.748-2.231-5.492-1.172 -0.625-1.487-3.636-1.367-4.637-0.771 -1.363-1.56-2.625-1.92-4.781-1.184C153.085 184.317 150.813 183.79 147.809 184.721zM37.85 187.905c0.559-2.065 4.329-2.205 6.192-2.293 0.222-0.29 1.76-2.22 4.603-1.372 1.635-2.172 5.477-1.409 6.157-1.299 0.359-0.053 1.34-1.833 4.544-0.923 1.073-1.914 4.254-1.537 5.117-1.384 -0.784-0.612-2.516-2.558-3.263-3.161 -1.739-0.409-4.089-0.677-4.711 0.952v0.162c-1.888-0.94-3.351-0.826-4.035 1.15l-0.076 0.058h-0.071c-2.126-0.988-4.355-1.174-5.95 0.554 -2.28-1.241-3.001 0.544-4.068 1.426v0.15c-2.532-1.052-4.421-0.347-5.343 1.056 -2.867-1.29-5.582-1.236-7.037 1.8 0.028 0.741 0.061 2.708 0.078 4.421C32.901 186.848 36.077 187.322 37.85 187.905z",
    fill: "#1fbad4",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2997",
    d: "M36.864 183.316c0.907 5.089 4.544 15.515 6.532 20.684C41.042 199.828 36.056 190.003 36.864 183.316 37.239 183.412 36.478 183.164 36.864 183.316zM42.081 182.099C43.768 189.9 47.522 199.561 59 212c-7.562-11.301-14.7-22.954-16.631-29.953C41.59 181.772 42.717 182.067 42.081 182.099zM60.829 201.982c-5.661-6.409-10.564-13.554-14.875-21.828C47.293 184.422 53.033 196.439 60.829 201.982zM60.829 201.982c0.711 0.685 1.432 1.36 2.171 2.018C62.255 203.338 61.546 202.658 60.829 201.982zM93.003 201.242c-9.773-6.18-24.836-17.555-32.916-24.079C63.499 182.655 80.449 196.903 93.003 201.242zM146.209 179.346c-8.199 12.52-18.991 19.974-30.811 28.156 16.005-7.792 24.545-15.85 30.554-28.205C145.479 179.051 146.566 179.333 146.209 179.346zM149.737 180.55l-0.049-0.098c-0.067-0.067-0.129-0.121-0.193-0.184 -4.209 10.353-11.793 19.05-19.876 28.134C139.203 200.562 145.786 192.152 149.737 180.55 148.956 180.625 150.366 180.227 149.737 180.55zM155.801 182.078c-0.038-0.115-0.093-0.211-0.141-0.316 -5.021 13.434-13.518 25.679-20.841 37.578C146.282 208.985 154.089 192.22 155.801 182.078 155.036 182.212 156.238 182.003 155.801 182.078zM160.387 182.611l-0.142-0.097c-0.164-0.343 0.261 0.156 0 0 -3.356 8.513-5.705 16.162-10.709 23.138C156.456 198.356 159.564 190.497 160.387 182.611 159.972 182.629 160.873 182.471 160.387 182.611zM164.122 183.111c-0.182 0.056 0.227-0.124 0.054-0.06L164.122 183.111c-0.32-0.325 0.567 0.094-0.175-0.001 -1.693 11.853-3.762 22.942-7.411 33.89C161.633 205.609 166.119 195.337 164.122 183.111zM140.204 179.196c-0.92 0.099 0.294-0.181-0.463 0.087 -6.862 5.453-16.478 12.178-18.003 13.162 0 0.052-6.032 6.635-10.884 10.22C124.619 193.569 132.183 189.37 140.204 179.196zM56.124 178.753c-0.943-0.664 8.542 14.193 27.968 22.305C72.525 194.913 62.603 187.144 56.124 178.753zM52.454 179.738l-0.076 0.058h-0.071c-1.379 0.36 11.743 19.392 22.617 27.106C66.155 198.831 52.454 179.738 52.454 179.738z",
    fill: "#009cb6",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2998",
    d: "M169.659 184.745c-0.479-2.571-3.071-2.677-5.51-1.79 -0.011-0.01-0.021 0-0.03 0.011 -0.521-0.531-1.963-0.97-3.76-0.45 -0.813-1.589-2.798-1.15-4.49-0.55 -0.855-2.565-4.369-2.609-6.08-1.555 -0.01-0.02-0.02-0.029-0.03-0.029 -1.962-1.964-2.96-1.581-3.96-1.337 -1.657-0.863-4.365-0.483-6.12 0.16 -5.478 4.403-12.335 9.208-18.04 13.24 0 0.021-8.18 6.05-18.01 13.31 -14.833-8.559-30.813-19.031-42.407-28.379 -1.858-0.413-4.176-0.703-4.823 1.029 0 0-0.01 0.01-0.01 0.021 -1.85-0.927-3.354-0.672-4.03 1.279 -0.01 0-0.01 0-0.01 0 -2.16-1.003-4.326-1.191-6.01 0.521 -0.706-0.388-1.449-0.553-2.19-0.23 -0.964 0.422-1.96 1.622-1.96 1.78 -2.406-1.004-4.412-0.232-5.28 1.08 -2.931-1.329-5.996-1.086-7.1 1.93 0.039 1.009 2.635 24.365 0.08 47.87 0 0 138.4 0.2 138.41 0.2C166.202 227.698 166.187 211.336 169.659 184.745zM30.619 232.365c4.04-16.406 0.239-36.055-0.57-46.6 1.057-2.96 4.225-3.26 6.62-2.32 0.648 4.702 1.932 9.223 4.52 14.28 -0.645-1.521-3.93-13.802-3.93-14.23 1.482-1.62 3.466-1.859 5.11-1.149 2.45 8.3 9.74 20.04 11.8 22.189 -1.262-1.442-11.239-21.45-11.62-22.45 1.039-1.396 2.211-2.01 3.79-1.31 4.081 8.162 9.302 14.953 10.64 16.31 0 0-10.229-16.459-10.23-16.46 1.268-1.227 3.667-0.994 5.45-0.399 0.01 0 0.02 0 0.02 0 25.958 33.4 6.071 5.747 0.39-0.24 0.01-0.04 0.03-0.09 0.05-0.12 1.03-2.18 2.77-1.11 3.95-0.36 5.05 7.28 18.47 16.591 19.69 16.99 -0.77-0.25-13.74-10.62-19.23-17.24 0.096-1 0.355-1.91 3.17-1.619 13.22 12.06 29.62 22.33 42.11 29.069 -12.8 9.45-27.84 20.59-31.25 23.25 1-0.574 50.413-33.261 69.74-50.79 2.095-0.292 3.832-0.058 4.74 0.28 0.01 0.01 0.03 0.01 0.04 0.021 -7.25 10.88-26.72 26.119-30.26 27.76 5.574-2.279 24.845-15.87 30.85-27.88 0.021 0 0.04-0.011 0.05 0 1.029-0.15 2.551 0.856 3.25 1.556 -0.01 0.01-0.02 0.03-0.029 0.05 -3.025 6.143-13.229 20.622-18.07 25.024 7.983-7.262 14.594-15.247 18.55-25.234 2.247-0.725 4.396-0.448 5.601 1.534 -2.163 5.533-0.775 4.988-10.051 19.35 -8.819 13.65-5.71 11.521-12.899 20.511 16.166-20.195 20.67-31.158 23.13-39.521 0-0.01 0.01-0.03 0.01-0.05 1.907-0.574 3.346-0.975 4.15 0.479 0 0 0.01 0 0 0.011 -2.65 7.569-6.2 15.14-7.2 17.229 6.371-9.852 5.551-9.614 7.479-17.33 1.772-0.517 3.196-0.165 3.74 0.29 -1.047 8.581-3.293 18.87-5.319 26.9 0.51-2 5.739-10.38 5.55-26.71 0.01-0.01 0.01-0.01 0-0.021 2.058-0.403 4.226-0.563 5.13 1.41 -2.068 16.94-6.141 27.786-1.41 47.641C128.171 231.516 79.125 231.362 30.619 232.365z",
    fill: "#008197",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left-move",
    transform: "matrix(1,0,0,1,0,0)",
    style: {
      display: "none"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2793",
    d: "M47.001 83.974c-1.376-2.313-5.638-7.997-9.98-6.603 -2.749 0.882-3.293 3.765-3.735 6.311 -0.588 3.386 0.471 10.083 1.389 12.503 0.881 2.325 3.533 6.816 5.264 8.527 2.13 2.1 4.775 8.793 5.194 9.487 0.66 1.097 1.536 2.745 4.122 2.538 2.853-0.229 4.584-1.742 5.856-1.999C58.253 114.109 50.582 89.995 47.001 83.974z",
    fill: "#f3d4cf",
    stroke: "#c5796d",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2794",
    d: "M44.197 97.997c-0.132-0.548 0.007-1.47 0.142-2.362 0.124-0.812 0.24-1.579 0.169-2.121 -0.267-2.032-1.773-5.893-2.757-7.985 -1.132-2.407-2.963-5.439-5.262-6.221 -0.95-0.324-1.575 0.063-1.938 0.456 -0.266 0.289-0.325 0.627-0.238 0.667 0.086 0.04 0.285-0.24 0.572-0.504 0.235-0.216 0.579-0.402 1.051-0.363 -0.19 1.011-1.167 6.49-0.744 10.225 0.333 2.938 1.593 5.131 1.79 5.46 0.029 0.346 0.077 0.685 0.148 1.014 0.929 4.287 4.971 9.163 6.378 10.758 0.259 0.295 0.531 0.47 0.598 0.398 0.066-0.072-0.094-0.364-0.353-0.66 -1.388-1.585-5.391-6.442-6.289-10.579 -0.952-4.389 2.318-10.896 3.048-12.272 0.371 0.646 0.687 1.267 0.93 1.785 0.19 0.406 0.402 0.881 0.619 1.395 -0.429 0.718-3.434 5.958-2.338 10.153 0.406 1.546 2.235 3.54 3.447 4.086 0.667 0.301 0.919 0.75 1.209 1.271 0.336 0.604 0.718 1.288 1.828 1.784 0.225 0.102 0.429 0.142 0.61 0.142 0.313 0 0.551-0.126 0.725-0.276 0.018 0.266 0.017 0.604 0.009 0.917 -0.012 0.404 0.042 0.737 0.137 0.745 0.094 0.008 0.196-0.313 0.207-0.717 0.016-0.496 0.013-1.11-0.072-1.403 -0.248-0.865-1.008-1.841-1.813-2.875C45.221 99.896 44.403 98.844 44.197 97.997zM36.95 94.196c-2.177-6.731 0.656-12.54 1.144-13.464 0.85 0.775 1.6 1.811 2.21 2.824C39.86 84.365 37.041 89.669 36.95 94.196zM46.341 104.042c-1.004-0.447-1.339-1.051-1.666-1.633 -0.293-0.527-0.598-1.072-1.369-1.42 -0.168-0.075-0.352-0.191-0.542-0.323 -2.486-5.906 0.272-8.488 0.963-9.017 0.211 0.722 0.369 1.384 0.439 1.915 0.063 0.488-0.052 1.263-0.167 2.012 -0.142 0.929-0.286 1.89-0.137 2.512 0.226 0.926 1.069 2.009 1.884 3.057 0.723 0.929 1.466 1.888 1.721 2.67C47.359 103.972 47.017 104.345 46.341 104.042z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right-move",
    transform: "matrix(1,0,0,1,0,0)",
    style: {
      display: "none"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2795",
    d: "M152.736 83.974c1.377-2.313 5.639-7.997 9.98-6.603 2.75 0.882 3.293 3.765 3.736 6.311 0.588 3.386-0.471 10.083-1.389 12.503 -0.881 2.325-3.533 6.816-5.266 8.527 -2.129 2.1-4.775 8.793-5.193 9.487 -0.658 1.097-1.535 2.745-4.121 2.538 -2.854-0.229-4.584-1.742-5.857-1.999C141.484 114.109 149.156 89.995 152.736 83.974z",
    fill: "#f3d4cf",
    stroke: "#c5796d",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2796",
    d: "M153.727 100.913c-0.805 1.033-1.564 2.009-1.813 2.875 -0.086 0.293-0.088 0.907-0.072 1.403 0.012 0.404 0.113 0.725 0.207 0.717s0.148-0.341 0.137-0.745c-0.008-0.313-0.008-0.651 0.01-0.917 0.174 0.15 0.412 0.276 0.725 0.276 0.182 0 0.385-0.04 0.609-0.142 1.109-0.496 1.492-1.18 1.828-1.784 0.289-0.52 0.543-0.969 1.209-1.271 1.213-0.546 3.041-2.54 3.447-4.086 1.096-4.194-1.908-9.435-2.338-10.153 0.217-0.513 0.43-0.988 0.619-1.395 0.244-0.518 0.559-1.139 0.93-1.785 0.73 1.377 4 7.883 3.049 12.272 -0.896 4.137-4.9 8.994-6.289 10.579 -0.258 0.296-0.418 0.588-0.352 0.66 0.066 0.071 0.338-0.104 0.598-0.398 1.406-1.596 5.449-6.471 6.379-10.758 0.07-0.329 0.117-0.668 0.146-1.014 0.197-0.329 1.459-2.523 1.791-5.46 0.422-3.735-0.555-9.214-0.744-10.225 0.473-0.039 0.814 0.146 1.051 0.363 0.287 0.264 0.486 0.544 0.572 0.504s0.027-0.378-0.238-0.667c-0.363-0.393-0.988-0.779-1.938-0.456 -2.299 0.782-4.131 3.814-5.262 6.221 -0.984 2.093-2.49 5.953-2.758 7.985 -0.072 0.542 0.045 1.309 0.17 2.121 0.135 0.892 0.273 1.814 0.141 2.362C155.336 98.844 154.518 99.896 153.727 100.913zM159.434 83.555c0.611-1.013 1.361-2.049 2.211-2.824 0.488 0.925 3.32 6.733 1.145 13.464C162.697 89.669 159.879 84.365 159.434 83.555zM152.27 103.816c0.254-0.782 0.998-1.741 1.721-2.67 0.816-1.048 1.658-2.131 1.885-3.057 0.148-0.622 0.004-1.583-0.137-2.512 -0.115-0.749-0.23-1.524-0.166-2.012 0.068-0.531 0.227-1.193 0.438-1.915 0.691 0.529 3.449 3.111 0.965 9.017 -0.191 0.132-0.375 0.248-0.543 0.323 -0.771 0.348-1.074 0.893-1.369 1.42 -0.326 0.582-0.662 1.186-1.666 1.633C152.721 104.345 152.379 103.972 152.27 103.816z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2999",
    d: "M100.002 0.867C66.384 0.919 39.082 28.09 39.134 61.564c0.008 5.316 0.704 10.471 2.002 15.382h0.001C41.15 77 52.68 114.915 55.158 127.369c1.382 6.945 9.063 15.403 16.531 20.513 6.967 4.767 11.263 11.388 28.313 11.388s21.346-6.621 28.313-11.388c7.468-5.109 15.149-13.567 16.531-20.513 2.479-12.454 14.009-50.37 14.02-50.423h0.002c1.298-4.911 1.994-10.066 2.002-15.382C160.923 28.09 133.62 0.919 100.002 0.867z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3000",
    d: "M146.772 22.738c7.478 10.183 11.917 22.87 11.898 36.626 -0.009 5.316-0.679 10.471-1.93 15.382h-0.002c-0.011 0.053-11.124 37.969-13.512 50.423 -1.335 6.945-8.737 15.403-15.935 20.513 -6.718 4.767-10.854 11.388-27.291 11.388 -16.434 0-20.575-6.621-27.291-11.388 -7.197-5.109-14.602-13.567-15.931-20.513 -2.391-12.454-13.504-50.37-13.515-50.423h0c-1.252-4.911-1.922-10.066-1.931-15.382 -0.021-13.752 4.416-26.435 11.889-36.617 -8.812 10.525-14.112 24.056-14.089 38.817 0.008 5.316 0.704 10.471 2.002 15.382h0.001C41.15 77 52.68 114.915 55.158 127.369c1.382 6.945 9.063 15.403 16.531 20.513 6.967 4.767 11.263 11.388 28.313 11.388s21.346-6.621 28.313-11.388c7.468-5.109 15.149-13.567 16.531-20.513 2.479-12.454 14.009-50.37 14.02-50.423h0.002c1.298-4.911 1.994-10.066 2.002-15.382C160.894 46.799 155.589 33.264 146.772 22.738z",
    fill: "#ebc3bd",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3001",
    d: "M100.002 0.867C66.384 0.919 39.082 28.09 39.134 61.564c0.008 5.316 0.704 10.471 2.002 15.382h0.001C41.15 77 52.68 114.915 55.158 127.369c1.382 6.945 9.063 15.403 16.531 20.513 6.967 4.767 11.263 11.388 28.313 11.388s21.346-6.621 28.313-11.388c7.468-5.109 15.149-13.567 16.531-20.513 2.479-12.454 14.009-50.37 14.02-50.423h0.002c1.298-4.911 1.994-10.066 2.002-15.382C160.923 28.09 133.62 0.919 100.002 0.867z",
    fill: "none",
    stroke: "#c5796d",
    strokeWidth: 1.5,
    opacity: 1
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2901",
    d: "M100.002 141.435c-4.158 0-5.133-3.232-5.133-3.232h10.267C105.136 138.202 103.659 141.435 100.002 141.435z",
    fill: "url(#SvgjsLinearGradient2902)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2905",
    d: "M87.536 132.96c2.756-0.951 6.239-3.625 8.432-3.723 1.133-0.051 2.351 0.87 3.574 1.166 0.851 0.207 3.264-1.156 4.13-1.166 2.272-0.022 6.326 2.771 8.769 3.723 0.135 0.055 0 0 0 0s-5.056 6.021-12.452 6.021C91.618 138.98 87.536 132.96 87.536 132.96S87.399 133.01 87.536 132.96z",
    fill: "#f771a9",
    stroke: "#e85391",
    strokeWidth: 0.75,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2906",
    d: "M112.808 132.902c-0.187-0.076-0.606-0.028-0.753-0.021 -0.304 0.016-0.546-0.117-1.214-0.129 -0.742-0.012-3.945-0.268-5.003-0.338 -2.129-0.143-3.824 0.666-5.848 0.666 -2.025 0-3.868-0.883-5.996-0.74 -1.057 0.072-4.113 0.395-4.857 0.412 -0.663 0.019-0.923 0.133-1.231 0.12 -0.143-0.007-0.595-0.05-0.771 0.05 -0.147 0.086-0.09 0.559 0.027 0.683 0.285 0.298 1.397-0.233 1.959-0.22 0.777 0.017 3.843-0.05 4.917-0.121 2.081-0.142 3.936 0.821 5.952 0.821s3.725-0.889 5.806-0.749c1.071 0.072 4.281 0.064 5.06 0.049 0.563-0.014 1.764 0.449 2.052 0.22C113.043 133.495 112.972 132.969 112.808 132.902z",
    fill: "#c92066",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2907",
    d: "M99.989 137.439c-3.37 0-6.645-1.154-9.241-3.306 1.307-0.072 2.652-0.277 3.961-0.219 1.613 0.07 3.144 0.705 4.756 0.813 1.742 0.116 3.358-0.488 5.064-0.695 1.422-0.171 2.931 0.059 4.357 0.111C106.335 136.101 103.244 137.439 99.989 137.439zM104.78 131.682c1.313-0.08 2.661 0.088 3.974 0.141 -1.43-0.712-2.953-1.553-4.549-1.807 -1.374-0.218-2.71 0.882-4.045 1.104 -1.506 0.25-2.69-1.15-4.16-1.15 -1.592 0.07-3.198 1.099-4.576 1.805 1.282-0.076 2.6-0.263 3.884-0.141 1.572 0.147 3.094 0.714 4.682 0.714C101.612 132.348 103.161 131.78 104.78 131.682z",
    fill: "#ff8ebd",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2908",
    d: "M99.941 136.486c-2.029 0-4.007-0.701-5.707-2.001 0.38-0.037 0.764-0.066 1.133-0.066 0.117 0 0.234 0.003 0.351 0.009 0.609 0.033 1.209 0.208 1.846 0.394 0.618 0.178 1.256 0.363 1.923 0.419 0.132 0.012 0.264 0.016 0.395 0.016 0.819 0 1.596-0.204 2.348-0.399 0.477-0.126 0.928-0.245 1.392-0.313 0.253-0.04 0.527-0.058 0.837-0.058 0.268 0 0.544 0.014 0.818 0.034C103.862 135.572 102.03 136.486 99.941 136.486z",
    fill: "#ffa8cc",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3288",
    d: "M61.952 84.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.798 91.758 63.174 90.04 61.952 84.523z",
    fill: "url(#SvgjsRadialGradient3289)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "matrix(1,0,0,1,-0.75,-0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2813",
    d: "M83.5 87c0 4.694-3.806 8.5-8.499 8.5 -4.694 0-8.501-3.806-8.501-8.5l0 0c0-4.694 3.807-8.5 8.501-8.5C79.694 78.499 83.5 82.305 83.5 87L83.5 87z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2814",
    d: "M74.048 78.595c-0.033 0.004-0.066 0.008-0.101 0.012 0.041 0.191 0.081 0.384 0.12 0.575C74.06 78.987 74.055 78.789 74.048 78.595zM74.066 79.18c0.099 2.793 0.262 5.282 0.732 6.183C75.047 84.377 74.625 81.92 74.066 79.18zM74.8 85.365c-0.061 0.236-0.153 0.397-0.294 0.452 -0.142 0.053-0.319-0.008-0.521-0.146 0.058 0.236 0.052 0.422-0.051 0.537 -0.102 0.114-0.285 0.142-0.527 0.11 0.16 0.184 0.242 0.353 0.206 0.5 -0.039 0.148-0.189 0.258-0.415 0.343 0.225 0.088 0.376 0.199 0.411 0.347 0.036 0.148-0.046 0.315-0.205 0.498 0.241-0.029 0.426 0.001 0.525 0.115 0.101 0.114 0.106 0.301 0.05 0.537 0.199-0.137 0.376-0.197 0.518-0.142 0.143 0.053 0.234 0.216 0.291 0.454 0.114-0.215 0.243-0.353 0.396-0.368 0.148-0.02 0.307 0.084 0.466 0.267 0.002-0.244 0.053-0.423 0.181-0.51 0.124-0.086 0.311-0.069 0.537 0.018 -0.11-0.216-0.148-0.398-0.078-0.534 0.071-0.135 0.245-0.207 0.487-0.235 -0.199-0.14-0.321-0.283-0.318-0.436 -0.001-0.153 0.119-0.296 0.321-0.434 -0.241-0.03-0.412-0.103-0.484-0.237 -0.07-0.135-0.031-0.319 0.081-0.535 -0.229 0.085-0.413 0.102-0.538 0.016 -0.126-0.086-0.177-0.267-0.178-0.51 -0.158 0.182-0.316 0.282-0.468 0.262C75.041 85.714 74.911 85.58 74.8 85.365zM75.66 85.471c0.679-0.758 1.446-3.13 2.224-5.813C76.674 82.174 75.662 84.453 75.66 85.471zM77.883 79.657c0.085-0.172 0.172-0.348 0.253-0.524 -0.03-0.011-0.06-0.024-0.09-0.037C77.992 79.284 77.938 79.472 77.883 79.657zM76.377 85.965c0.953-0.357 2.736-2.101 4.671-4.115C78.808 83.517 76.851 85.065 76.377 85.965zM81.048 81.851c0.142-0.106 0.287-0.213 0.433-0.318 -0.021-0.025-0.043-0.047-0.06-0.07C81.297 81.59 81.174 81.722 81.048 81.851zM76.777 86.738c1.01 0.125 3.399-0.591 6.052-1.475C80.068 85.698 77.617 86.159 76.777 86.738zM82.829 85.263c0.156-0.022 0.318-0.048 0.478-0.073 -0.007-0.026-0.013-0.054-0.02-0.081C83.135 85.16 82.979 85.212 82.829 85.263zM76.775 87.606c0.836 0.583 3.284 1.057 6.038 1.505C80.171 88.214 77.786 87.484 76.775 87.606zM82.813 89.111c0.135 0.047 0.271 0.095 0.404 0.138 0.007-0.024 0.013-0.047 0.018-0.071C83.098 89.158 82.954 89.135 82.813 89.111zM76.367 88.375c0.471 0.902 2.42 2.462 4.649 4.142C79.092 90.492 77.32 88.737 76.367 88.375zM81.018 92.514c0.083 0.087 0.17 0.179 0.253 0.268 0.014-0.017 0.027-0.031 0.043-0.046C81.215 92.662 81.113 92.587 81.018 92.514zM75.652 88.867c-0.004 1.019 0.995 3.302 2.191 5.827C77.079 92.006 76.327 89.628 75.652 88.867zM77.844 94.694c0.03 0.106 0.062 0.215 0.09 0.324 0.021-0.008 0.036-0.015 0.055-0.02C77.941 94.896 77.892 94.793 77.844 94.694zM74.788 88.968c-0.476 0.902-0.653 3.386-0.768 6.178C74.594 92.413 75.031 89.958 74.788 88.968zM74.021 95.146c-0.023 0.106-0.044 0.214-0.066 0.323 0.02 0.004 0.035 0.005 0.055 0.007C74.013 95.368 74.018 95.254 74.021 95.146zM73.979 88.657c-0.844 0.576-2.154 2.697-3.553 5.114C72.204 91.617 73.733 89.645 73.979 88.657zM70.427 93.771c-0.074 0.09-0.152 0.185-0.229 0.274 0.018 0.012 0.034 0.02 0.053 0.034C70.309 93.976 70.369 93.873 70.427 93.771zM73.405 88.006c-1.015 0.119-3.16 1.385-5.522 2.875C70.46 89.801 72.726 88.768 73.405 88.006zM67.883 90.884c-0.122 0.051-0.247 0.102-0.372 0.156 0.009 0.019 0.021 0.038 0.033 0.057C67.658 91.027 67.771 90.954 67.883 90.884zM73.198 87.161c-0.951-0.365-3.441-0.238-6.227-0.016C69.755 87.383 72.244 87.521 73.198 87.161zM66.972 87.145c-0.151-0.014-0.308-0.028-0.457-0.041 -0.001 0.027-0.003 0.053-0.001 0.08C66.669 87.169 66.822 87.156 66.972 87.145zM73.407 86.318c-0.67-0.763-2.932-1.809-5.499-2.905C70.259 84.915 72.397 86.196 73.407 86.318zM67.908 83.413c-0.147-0.095-0.297-0.189-0.446-0.285 -0.013 0.026-0.026 0.053-0.041 0.078C67.585 83.276 67.75 83.344 67.908 83.413zM73.985 85.67c-0.239-0.989-1.758-2.967-3.521-5.132C71.849 82.963 73.147 85.09 73.985 85.67zM70.465 80.538c-0.095-0.163-0.188-0.329-0.281-0.494 -0.026 0.018-0.055 0.037-0.079 0.054C70.224 80.245 70.348 80.393 70.465 80.538z",
    fill: "url(#SvgjsRadialGradient2815)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2818",
    d: "M76.255 78.622c-0.034-0.004-0.066-0.01-0.1-0.014 -0.011 0.196-0.022 0.393-0.034 0.586C76.164 79.004 76.211 78.812 76.255 78.622zM76.12 79.193c-0.627 2.724-1.114 5.17-0.892 6.162C75.724 84.467 75.95 81.984 76.12 79.193zM75.229 85.356c-0.119 0.212-0.25 0.344-0.401 0.36 -0.15 0.014-0.306-0.091-0.464-0.276 -0.006 0.243-0.06 0.421-0.188 0.505 -0.128 0.083-0.313 0.063-0.539-0.03 0.107 0.219 0.143 0.403 0.069 0.536 -0.075 0.133-0.249 0.201-0.489 0.224 0.194 0.144 0.312 0.289 0.308 0.441 -0.003 0.152-0.126 0.292-0.327 0.428 0.24 0.034 0.41 0.111 0.478 0.247 0.067 0.136 0.025 0.318-0.091 0.532 0.229-0.081 0.414-0.093 0.537-0.003 0.123 0.088 0.17 0.27 0.164 0.514 0.166-0.177 0.325-0.278 0.478-0.253 0.148 0.02 0.274 0.16 0.382 0.379 0.064-0.236 0.16-0.396 0.306-0.447 0.143-0.051 0.318 0.014 0.515 0.157 -0.051-0.237-0.041-0.423 0.063-0.536s0.29-0.136 0.532-0.102c-0.157-0.187-0.238-0.356-0.195-0.504 0.039-0.148 0.192-0.255 0.423-0.336 -0.226-0.091-0.372-0.206-0.407-0.354 -0.032-0.149 0.053-0.316 0.218-0.495 -0.243 0.023-0.427-0.009-0.524-0.125 -0.099-0.115-0.102-0.303-0.039-0.538 -0.201 0.134-0.38 0.19-0.521 0.132C75.37 85.756 75.281 85.593 75.229 85.356zM76.033 85.683c0.852-0.558 2.206-2.65 3.652-5.04C77.865 82.76 76.298 84.699 76.033 85.683zM79.685 80.641c0.126-0.145 0.255-0.292 0.38-0.44 -0.027-0.019-0.052-0.04-0.078-0.06C79.886 80.31 79.785 80.477 79.685 80.641zM76.597 86.345c1.013-0.099 3.187-1.322 5.577-2.767C79.578 84.609 77.287 85.598 76.597 86.345zM82.173 83.579c0.165-0.065 0.333-0.131 0.501-0.195 -0.014-0.029-0.029-0.056-0.04-0.083C82.481 83.392 82.328 83.487 82.173 83.579zM76.783 87.194c0.943 0.382 3.437 0.309 6.227 0.142C80.231 87.042 77.745 86.853 76.783 87.194zM83.01 87.336c0.158 0.019 0.32 0.036 0.48 0.053 0.001-0.027 0.002-0.055 0.003-0.083C83.332 87.316 83.168 87.326 83.01 87.336zM76.558 88.033c0.655 0.78 2.898 1.871 5.442 3.017C79.679 89.499 77.565 88.177 76.558 88.033zM82 91.049c0.117 0.08 0.236 0.161 0.354 0.238 0.013-0.021 0.024-0.042 0.035-0.063C82.262 91.168 82.129 91.109 82 91.049zM75.964 88.67c0.221 0.993 1.699 3.004 3.419 5.205C78.048 91.419 76.791 89.266 75.964 88.67zM79.384 93.872c0.059 0.106 0.117 0.217 0.176 0.325 0.018-0.013 0.034-0.023 0.053-0.034C79.536 94.065 79.458 93.967 79.384 93.872zM75.146 88.96c-0.267 0.982 0.107 3.447 0.608 6.195C75.711 92.361 75.601 89.87 75.146 88.96zM75.754 95.155c0.002 0.11 0.004 0.224 0.004 0.337 0.021-0.003 0.038-0.005 0.058-0.005C75.796 95.376 75.775 95.264 75.754 95.155zM74.285 88.834c-0.693 0.748-1.508 3.102-2.341 5.769C73.205 92.11 74.265 89.853 74.285 88.834zM71.944 94.603c-0.05 0.096-0.099 0.195-0.147 0.295 0.017 0.008 0.032 0.013 0.051 0.021C71.879 94.815 71.913 94.707 71.944 94.603zM73.584 88.324c-0.964 0.338-2.779 2.048-4.756 4.021C71.104 90.724 73.091 89.215 73.584 88.324zM68.828 92.345c-0.095 0.067-0.194 0.138-0.29 0.206 0.014 0.016 0.027 0.028 0.041 0.045C68.661 92.511 68.746 92.428 68.828 92.345zM73.197 87.546c-1.01-0.148-3.409 0.521-6.078 1.349C69.889 88.518 72.345 88.106 73.197 87.546zM67.119 88.897c-0.131 0.018-0.265 0.034-0.4 0.054 0.005 0.021 0.011 0.042 0.018 0.063C66.865 88.977 66.993 88.936 67.119 88.897zM73.217 86.677c-0.824-0.599-3.263-1.121-6.01-1.627C69.833 86 72.202 86.777 73.217 86.677zM67.207 85.05c-0.143-0.052-0.29-0.106-0.432-0.158 -0.008 0.026-0.016 0.051-0.021 0.077C66.907 84.995 67.06 85.022 67.207 85.05zM73.637 85.917c-0.45-0.911-2.363-2.506-4.561-4.23C70.959 83.747 72.693 85.538 73.637 85.917zM69.076 81.688c-0.118-0.13-0.236-0.26-0.355-0.391 -0.021 0.022-0.041 0.044-0.061 0.065C68.8 81.471 68.941 81.58 69.076 81.688zM74.363 85.44c0.024-1.017-0.93-3.321-2.073-5.868C72.999 82.273 73.704 84.663 74.363 85.44zM72.29 79.572c-0.049-0.182-0.096-0.366-0.144-0.55 -0.029 0.01-0.062 0.021-0.09 0.032C72.134 79.227 72.214 79.401 72.29 79.572z",
    fill: "url(#SvgjsRadialGradient2819)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2822",
    d: "M78.334 87c0 1.842-1.492 3.333-3.333 3.333S71.666 88.841 71.666 87c0-1.841 1.494-3.334 3.335-3.334C76.844 83.666 78.334 85.159 78.334 87z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2823",
    d: "M78.334 87c0 1.842-1.492 3.333-3.333 3.333S71.666 88.841 71.666 87c0-1.841 1.494-3.334 3.335-3.334C76.844 83.666 78.334 85.159 78.334 87z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2824",
    d: "M70.35 90.893c0.636-0.427 1.5-0.255 1.927 0.38 0.427 0.637 0.258 1.5-0.379 1.927 -0.638 0.429-1.5 0.258-1.927-0.378C69.544 92.185 69.713 91.32 70.35 90.893L70.35 90.893z",
    fill: "url(#SvgjsLinearGradient2825)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2828",
    d: "M77.635 86.536c-0.356 0.53-1.373 0.468-2.275-0.136 -0.903-0.605-1.346-1.526-0.991-2.055l0.001-0.001c0.354-0.53 1.372-0.469 2.274 0.137 0.903 0.604 1.346 1.524 0.992 2.054C77.635 86.536 77.635 86.536 77.635 86.536z",
    fill: "url(#SvgjsLinearGradient2829)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2832",
    d: "M81.682 85.121c-0.806 1.237-2.884 1.31-4.641 0.166 -1.756-1.145-2.527-3.075-1.722-4.311 0.806-1.235 2.884-1.31 4.641-0.166C81.715 81.956 82.485 83.887 81.682 85.121L81.682 85.121z",
    fill: "url(#SvgjsLinearGradient2833)",
    opacity: 0.75
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3310",
    d: "M55.5 88c0 13.807 8.06 24.999 18 24.999s18-11.192 18-24.999c0-13.808-8.06-25-18-25S55.5 74.192 55.5 88zM61.952 84.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.798 91.758 63.174 90.04 61.952 84.523z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3311",
    d: "M72.462 92.163c3.614 0.398 13.873-1.561 14.253-2.847 0.687-2.32-4.534-6.921-12.052-7.844 -6.46-0.792-11.563 0.345-12.556 2.128 0.898-6.4 7.7-11.397 15.987-11.434 8.911-0.037 16.148 5.676 16.172 12.765 0.021 7.088-7.185 12.862-16.095 12.902 -8.913 0.037-16.149-5.676-16.173-12.764 0-0.105 0.016-0.208 0.019-0.313C63.348 90.083 68.852 91.764 72.462 92.163z",
    fill: "url(#SvgjsRadialGradient3312)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3316",
    d: "M61.952 84.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.798 91.758 63.174 90.04 61.952 84.523z",
    fill: "url(#SvgjsRadialGradient3317)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3320",
    d: "M62.349 79.417c4.208-1.978 9.35-2.16 13.838-1.005 2.404 0.561 4.965 1.285 7.063 2.638 1.945 1.135 3.525 2.5 5.002 4.19 -1.342-1.701-2.773-3.118-4.623-4.27 -2.276-1.416-4.769-2.294-7.364-2.916C71.678 76.928 66.542 77.184 62.349 79.417z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3321",
    d: "M57.318 80.972c0 0 2.328 0.881 3.595 0.62 -0.39-0.459-1.096-1.604-1.096-1.604s1.853 0.551 3.151 0.032c0.88-0.352 4.065-1 5.456-1.066 1.687-0.082 5.073 0.125 6.735 0.424 3.374 0.608 8.985 2.63 11.678 7.184 0.255 0.572 1.407 0.921 1.407 0.921s-1.02-0.215-1.149 0.042c-0.282 0.561 1.298 2.016 1.496 2.197 -0.161-0.145-1.289-1.135-1.722-0.967 -0.061 0.022-0.137 0.388-0.155 0.482 0.3-2.426-4.838-6.746-12.052-7.604 -7.52-0.894-13.217 0.743-12.711 2.958 1.222 5.348 6.846 7.013 10.51 7.405 2.526 0.271 8.298-0.577 11.675-1.537l1.011-0.317c-1.999 1.009-7.524 2.195-9.767 2.403 -0.744 0.07-2.24 0.104-2.986 0.085 -5.949-0.158-10.16-3.179-11.729-7.26 -0.125-0.328-0.494-0.619-0.838-0.696 -1.604-0.361-5.096-1.811-5.096-1.811 2.32 0.361 3.483 0.674 5.305 0.059C58.257 82.256 57.318 80.972 57.318 80.972z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3295",
    d: "M138.048 84.523c0.506-2.285-5.191-3.973-12.711-3.051 -7.518 0.923-12.738 5.524-12.052 7.844 0.38 1.286 10.639 3.245 14.253 2.847C131.202 91.758 136.826 90.04 138.048 84.523z",
    fill: "url(#SvgjsRadialGradient3296)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "matrix(1,0,0,1,0.75,-0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2836",
    d: "M133.5 87c0 4.694-3.806 8.5-8.499 8.5 -4.694 0-8.501-3.806-8.501-8.5l0 0c0-4.694 3.807-8.5 8.501-8.5C129.694 78.499 133.5 82.305 133.5 87L133.5 87z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2837",
    d: "M124.048 78.595c-0.033 0.004-0.066 0.008-0.101 0.012 0.041 0.191 0.081 0.384 0.12 0.575C124.06 78.987 124.055 78.789 124.048 78.595zM124.066 79.18c0.099 2.793 0.262 5.282 0.732 6.183C125.047 84.377 124.625 81.92 124.066 79.18zM124.8 85.365c-0.061 0.236-0.153 0.397-0.294 0.452 -0.142 0.053-0.319-0.008-0.521-0.146 0.058 0.236 0.052 0.422-0.051 0.537 -0.102 0.114-0.285 0.142-0.527 0.11 0.16 0.184 0.242 0.353 0.206 0.5 -0.039 0.148-0.189 0.258-0.415 0.343 0.225 0.088 0.376 0.199 0.411 0.347 0.036 0.148-0.046 0.315-0.205 0.498 0.241-0.029 0.426 0.001 0.525 0.115 0.101 0.114 0.106 0.301 0.05 0.537 0.199-0.137 0.376-0.197 0.518-0.142 0.143 0.053 0.234 0.216 0.291 0.454 0.114-0.215 0.243-0.353 0.396-0.368 0.148-0.02 0.307 0.084 0.466 0.267 0.002-0.244 0.053-0.423 0.181-0.51 0.124-0.086 0.311-0.069 0.537 0.018 -0.11-0.216-0.148-0.398-0.078-0.534 0.071-0.135 0.245-0.207 0.487-0.235 -0.199-0.14-0.321-0.283-0.318-0.436 -0.001-0.153 0.119-0.296 0.321-0.434 -0.241-0.03-0.412-0.103-0.484-0.237 -0.07-0.135-0.031-0.319 0.081-0.535 -0.229 0.085-0.413 0.102-0.538 0.016 -0.126-0.086-0.177-0.267-0.178-0.51 -0.158 0.182-0.316 0.282-0.468 0.262C125.041 85.714 124.911 85.58 124.8 85.365zM125.66 85.471c0.679-0.758 1.446-3.13 2.224-5.813C126.674 82.174 125.662 84.453 125.66 85.471zM127.883 79.657c0.085-0.172 0.172-0.348 0.253-0.524 -0.03-0.011-0.06-0.024-0.09-0.037C127.992 79.284 127.938 79.472 127.883 79.657zM126.377 85.965c0.953-0.357 2.736-2.101 4.671-4.115C128.808 83.517 126.851 85.065 126.377 85.965zM131.048 81.851c0.142-0.106 0.287-0.213 0.433-0.318 -0.021-0.025-0.043-0.047-0.06-0.07C131.297 81.59 131.174 81.722 131.048 81.851zM126.777 86.738c1.01 0.125 3.399-0.591 6.052-1.475C130.068 85.698 127.617 86.159 126.777 86.738zM132.829 85.263c0.156-0.022 0.318-0.048 0.478-0.073 -0.007-0.026-0.013-0.054-0.02-0.081C133.135 85.16 132.979 85.212 132.829 85.263zM126.775 87.606c0.836 0.583 3.284 1.057 6.038 1.505C130.171 88.214 127.786 87.484 126.775 87.606zM132.813 89.111c0.135 0.047 0.271 0.095 0.404 0.138 0.007-0.024 0.013-0.047 0.018-0.071C133.098 89.158 132.954 89.135 132.813 89.111zM126.367 88.375c0.471 0.902 2.42 2.462 4.649 4.142C129.092 90.492 127.32 88.737 126.367 88.375zM131.018 92.514c0.083 0.087 0.17 0.179 0.253 0.268 0.014-0.017 0.027-0.031 0.043-0.046C131.215 92.662 131.113 92.587 131.018 92.514zM125.652 88.867c-0.004 1.019 0.995 3.302 2.191 5.827C127.079 92.006 126.327 89.628 125.652 88.867zM127.844 94.694c0.03 0.106 0.062 0.215 0.09 0.324 0.021-0.008 0.036-0.015 0.055-0.02C127.941 94.896 127.892 94.793 127.844 94.694zM124.788 88.968c-0.476 0.902-0.653 3.386-0.768 6.178C124.594 92.413 125.031 89.958 124.788 88.968zM124.021 95.146c-0.023 0.106-0.044 0.214-0.066 0.323 0.02 0.004 0.035 0.005 0.055 0.007C124.013 95.368 124.018 95.254 124.021 95.146zM123.979 88.657c-0.844 0.576-2.154 2.697-3.553 5.114C122.204 91.617 123.733 89.645 123.979 88.657zM120.427 93.771c-0.074 0.09-0.152 0.185-0.229 0.274 0.018 0.012 0.034 0.02 0.053 0.034C120.309 93.976 120.369 93.873 120.427 93.771zM123.405 88.006c-1.015 0.119-3.16 1.385-5.522 2.875C120.46 89.801 122.726 88.768 123.405 88.006zM117.883 90.884c-0.122 0.051-0.247 0.102-0.372 0.156 0.009 0.019 0.021 0.038 0.033 0.057C117.658 91.027 117.771 90.954 117.883 90.884zM123.198 87.161c-0.951-0.365-3.441-0.238-6.227-0.016C119.755 87.383 122.244 87.521 123.198 87.161zM116.972 87.145c-0.151-0.014-0.308-0.028-0.457-0.041 -0.001 0.027-0.003 0.053-0.001 0.08C116.669 87.169 116.822 87.156 116.972 87.145zM123.407 86.318c-0.67-0.763-2.932-1.809-5.499-2.905C120.259 84.915 122.397 86.196 123.407 86.318zM117.908 83.413c-0.147-0.095-0.297-0.189-0.446-0.285 -0.013 0.026-0.026 0.053-0.041 0.078C117.585 83.276 117.75 83.344 117.908 83.413zM123.985 85.67c-0.239-0.989-1.758-2.967-3.521-5.132C121.849 82.963 123.147 85.09 123.985 85.67zM120.465 80.538c-0.095-0.163-0.188-0.329-0.281-0.494 -0.026 0.018-0.055 0.037-0.079 0.054C120.224 80.245 120.348 80.393 120.465 80.538z",
    fill: "url(#SvgjsRadialGradient2838)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2841",
    d: "M126.255 78.622c-0.034-0.004-0.066-0.01-0.1-0.014 -0.011 0.196-0.022 0.393-0.034 0.586C126.164 79.004 126.211 78.812 126.255 78.622zM126.12 79.193c-0.627 2.724-1.114 5.17-0.892 6.162C125.724 84.467 125.95 81.984 126.12 79.193zM125.229 85.356c-0.119 0.212-0.25 0.344-0.401 0.36 -0.15 0.014-0.306-0.091-0.464-0.276 -0.006 0.243-0.06 0.421-0.188 0.505 -0.128 0.083-0.313 0.063-0.539-0.03 0.107 0.219 0.143 0.403 0.069 0.536 -0.075 0.133-0.249 0.201-0.489 0.224 0.194 0.144 0.312 0.289 0.308 0.441 -0.003 0.152-0.126 0.292-0.327 0.428 0.24 0.034 0.41 0.111 0.478 0.247 0.067 0.136 0.025 0.318-0.091 0.532 0.229-0.081 0.414-0.093 0.537-0.003 0.123 0.088 0.17 0.27 0.164 0.514 0.166-0.177 0.325-0.278 0.478-0.253 0.148 0.02 0.274 0.16 0.382 0.379 0.064-0.236 0.16-0.396 0.306-0.447 0.143-0.051 0.318 0.014 0.515 0.157 -0.051-0.237-0.041-0.423 0.063-0.536s0.29-0.136 0.532-0.102c-0.157-0.187-0.238-0.356-0.195-0.504 0.039-0.148 0.192-0.255 0.423-0.336 -0.226-0.091-0.372-0.206-0.407-0.354 -0.032-0.149 0.053-0.316 0.218-0.495 -0.243 0.023-0.427-0.009-0.524-0.125 -0.099-0.115-0.102-0.303-0.039-0.538 -0.201 0.134-0.38 0.19-0.521 0.132C125.37 85.756 125.281 85.593 125.229 85.356zM126.033 85.683c0.852-0.558 2.206-2.65 3.652-5.04C127.865 82.76 126.298 84.699 126.033 85.683zM129.685 80.641c0.126-0.145 0.255-0.292 0.38-0.44 -0.027-0.019-0.052-0.04-0.078-0.06C129.886 80.31 129.785 80.477 129.685 80.641zM126.597 86.345c1.013-0.099 3.187-1.322 5.577-2.767C129.578 84.609 127.287 85.598 126.597 86.345zM132.173 83.579c0.165-0.065 0.333-0.131 0.501-0.195 -0.014-0.029-0.029-0.056-0.04-0.083C132.481 83.392 132.328 83.487 132.173 83.579zM126.783 87.194c0.943 0.382 3.437 0.309 6.227 0.142C130.231 87.042 127.745 86.853 126.783 87.194zM133.01 87.336c0.158 0.019 0.32 0.036 0.48 0.053 0.001-0.027 0.002-0.055 0.003-0.083C133.332 87.316 133.168 87.326 133.01 87.336zM126.558 88.033c0.655 0.78 2.898 1.871 5.442 3.017C129.679 89.499 127.565 88.177 126.558 88.033zM132 91.049c0.117 0.08 0.236 0.161 0.354 0.238 0.013-0.021 0.024-0.042 0.035-0.063C132.262 91.168 132.129 91.109 132 91.049zM125.964 88.67c0.221 0.993 1.699 3.004 3.419 5.205C128.048 91.419 126.791 89.266 125.964 88.67zM129.384 93.872c0.059 0.106 0.117 0.217 0.176 0.325 0.018-0.013 0.034-0.023 0.053-0.034C129.536 94.065 129.458 93.967 129.384 93.872zM125.146 88.96c-0.267 0.982 0.107 3.447 0.608 6.195C125.711 92.361 125.601 89.87 125.146 88.96zM125.754 95.155c0.002 0.11 0.004 0.224 0.004 0.337 0.021-0.003 0.038-0.005 0.058-0.005C125.796 95.376 125.775 95.264 125.754 95.155zM124.285 88.834c-0.693 0.748-1.508 3.102-2.341 5.769C123.205 92.11 124.265 89.853 124.285 88.834zM121.944 94.603c-0.05 0.096-0.099 0.195-0.147 0.295 0.017 0.008 0.032 0.013 0.051 0.021C121.879 94.815 121.913 94.707 121.944 94.603zM123.584 88.324c-0.964 0.338-2.779 2.048-4.756 4.021C121.104 90.724 123.091 89.215 123.584 88.324zM118.828 92.345c-0.095 0.067-0.194 0.138-0.29 0.206 0.014 0.016 0.027 0.028 0.041 0.045C118.661 92.511 118.746 92.428 118.828 92.345zM123.197 87.546c-1.01-0.148-3.409 0.521-6.078 1.349C119.889 88.518 122.345 88.106 123.197 87.546zM117.119 88.897c-0.131 0.018-0.265 0.034-0.4 0.054 0.005 0.021 0.011 0.042 0.018 0.063C116.865 88.977 116.993 88.936 117.119 88.897zM123.217 86.677c-0.824-0.599-3.263-1.121-6.01-1.627C119.833 86 122.202 86.777 123.217 86.677zM117.207 85.05c-0.143-0.052-0.29-0.106-0.432-0.158 -0.008 0.026-0.016 0.051-0.021 0.077C116.907 84.995 117.06 85.022 117.207 85.05zM123.637 85.917c-0.45-0.911-2.363-2.506-4.561-4.23C120.959 83.747 122.693 85.538 123.637 85.917zM119.076 81.688c-0.118-0.13-0.236-0.26-0.355-0.391 -0.021 0.022-0.041 0.044-0.061 0.065C118.8 81.471 118.941 81.58 119.076 81.688zM124.363 85.44c0.024-1.017-0.93-3.321-2.073-5.868C122.999 82.273 123.704 84.663 124.363 85.44zM122.29 79.572c-0.049-0.182-0.096-0.366-0.144-0.55 -0.029 0.01-0.062 0.021-0.09 0.032C122.134 79.227 122.214 79.401 122.29 79.572z",
    fill: "url(#SvgjsRadialGradient2842)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2845",
    d: "M128.334 87c0 1.842-1.492 3.333-3.333 3.333s-3.335-1.492-3.335-3.333c0-1.841 1.494-3.334 3.335-3.334C126.844 83.666 128.334 85.159 128.334 87z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2846",
    d: "M128.334 87c0 1.842-1.492 3.333-3.333 3.333s-3.335-1.492-3.335-3.333c0-1.841 1.494-3.334 3.335-3.334C126.844 83.666 128.334 85.159 128.334 87z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2847",
    d: "M120.35 90.893c0.636-0.427 1.5-0.255 1.927 0.38 0.427 0.637 0.258 1.5-0.379 1.927 -0.638 0.429-1.5 0.258-1.927-0.378C119.544 92.185 119.713 91.32 120.35 90.893L120.35 90.893z",
    fill: "url(#SvgjsLinearGradient2848)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2851",
    d: "M127.635 86.536c-0.356 0.53-1.373 0.468-2.275-0.136 -0.903-0.605-1.346-1.526-0.991-2.055l0.001-0.001c0.354-0.53 1.372-0.469 2.274 0.137 0.903 0.604 1.346 1.524 0.992 2.054C127.635 86.536 127.635 86.536 127.635 86.536z",
    fill: "url(#SvgjsLinearGradient2852)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2855",
    d: "M131.682 85.121c-0.806 1.237-2.884 1.31-4.641 0.166 -1.756-1.145-2.527-3.075-1.722-4.311 0.806-1.235 2.884-1.31 4.641-0.166C131.715 81.956 132.485 83.887 131.682 85.121L131.682 85.121z",
    fill: "url(#SvgjsLinearGradient2856)",
    opacity: 0.75
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3330",
    d: "M126.5 63c-9.94 0-18 11.192-18 25 0 13.807 8.06 24.999 18 24.999s18-11.192 18-24.999C144.5 74.192 136.44 63 126.5 63zM127.538 92.163c-3.614 0.398-13.873-1.561-14.253-2.847 -0.687-2.32 4.534-6.921 12.052-7.844 7.52-0.922 13.217 0.767 12.711 3.051C136.826 90.04 131.202 91.758 127.538 92.163z",
    fill: "#f3d4cf",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3331",
    d: "M127.538 92.163c-3.614 0.398-13.873-1.561-14.253-2.847 -0.687-2.32 4.534-6.921 12.052-7.844 6.46-0.792 11.563 0.345 12.556 2.128 -0.898-6.4-7.7-11.397-15.987-11.434 -8.911-0.037-16.148 5.676-16.172 12.765 -0.021 7.088 7.185 12.862 16.095 12.902 8.913 0.037 16.149-5.676 16.173-12.764 0-0.105-0.016-0.208-0.019-0.313C136.652 90.083 131.148 91.764 127.538 92.163z",
    fill: "url(#SvgjsRadialGradient3332)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3336",
    d: "M138.048 84.523c0.506-2.285-5.191-3.973-12.711-3.051 -7.518 0.923-12.738 5.524-12.052 7.844 0.38 1.286 10.639 3.245 14.253 2.847C131.202 91.758 136.826 90.04 138.048 84.523z",
    fill: "url(#SvgjsRadialGradient3337)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3340",
    d: "M137.651 79.417c-4.208-1.978-9.35-2.16-13.838-1.005 -2.404 0.561-4.965 1.285-7.063 2.638 -1.945 1.135-3.525 2.5-5.002 4.19 1.342-1.701 2.773-3.118 4.623-4.27 2.276-1.416 4.769-2.294 7.364-2.916C128.322 76.928 133.458 77.184 137.651 79.417z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3341",
    d: "M142.682 80.972c0 0-2.328 0.881-3.595 0.62 0.39-0.459 1.096-1.604 1.096-1.604s-1.853 0.551-3.151 0.032c-0.88-0.352-4.065-1-5.456-1.066 -1.687-0.082-5.073 0.125-6.735 0.424 -3.374 0.608-8.985 2.63-11.678 7.184 -0.255 0.572-1.407 0.921-1.407 0.921s1.02-0.215 1.149 0.042c0.282 0.561-1.298 2.016-1.496 2.197 0.161-0.145 1.289-1.135 1.722-0.967 0.061 0.022 0.137 0.388 0.155 0.482 -0.3-2.426 4.838-6.746 12.052-7.604 7.52-0.894 13.217 0.743 12.711 2.958 -1.222 5.348-6.846 7.013-10.51 7.405 -2.526 0.271-8.298-0.577-11.675-1.537l-1.011-0.317c1.999 1.009 7.524 2.195 9.767 2.403 0.744 0.07 2.24 0.104 2.986 0.085 5.949-0.158 10.16-3.179 11.729-7.26 0.125-0.328 0.494-0.619 0.838-0.696 1.604-0.361 5.096-1.811 5.096-1.811 -2.32 0.361-3.483 0.674-5.305 0.059C141.743 82.256 142.682 80.972 142.682 80.972z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2772",
    d: "M140.204 113.007c0.035 22.275-17.995 40.365-40.273 40.396 -22.274 0.036-40.361-17.993-40.396-40.272C59.501 90.857 77.53 72.77 99.808 72.735 122.083 72.701 140.171 90.73 140.204 113.007z",
    fill: "url(#SvgjsRadialGradient2773)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2776",
    d: "M135,55.999c0,19.329-15.671,35-35,35c-19.329,0-35-15.671-35-35s15.671-35,35-35C119.329,20.999,135,36.67,135,55.999z",
    fill: "url(#SvgjsRadialGradient2777)",
    opacity: 1
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2797",
    d: "M74.799 69.068c-4.425-0.475-21.252 3.714-21.252 3.714s16.789-6.74 23.757-5.667c5.188 0.798 14.397 5.077 12.706 7.339C88.649 76.275 84.408 70.1 74.799 69.068z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2798",
    d: "M109.731 74.187c-1.713-2.292 7.592-6.31 13.546-6.804 7.117-0.59 22.914 4.085 22.914 4.085s-15.9-2.628-20.377-2.106C115.998 70.506 111.11 76.031 109.731 74.187z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2909",
    d: "M92.281 116.235c-0.745 2.063 5.028 4.289 7.218 4.426 2.374 0.147 9.024-2.899 7.896-4.991 -1.185-2.197-5.63-0.286-7.547-0.286C97.94 115.384 93.276 113.479 92.281 116.235z",
    fill: "#e4b3ab",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2910",
    d: "M102.207 117.221c-0.243-0.522 1.194-1.333 1.748-1.493 0.777-0.226 2.505 0.238 2.438 0.831 -0.06 0.521-1.603-0.169-2.105-0.022C103.767 116.687 102.435 117.712 102.207 117.221zM95.214 116.742c0.706 0 1.753 0.457 1.945 0.057 0.229-0.479-1.56-1.065-2.086-1 -0.434 0.052-1.991 0.958-1.777 1.338C93.496 117.49 94.284 116.742 95.214 116.742z",
    fill: "#c5796d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2911",
    d: "M99.857 113.479c0.669 0 1.807-0.637 1.978-1.9 0.754-5.575-0.521-20.246-1.978-20.246 -1.365 0-2.508 15.024-2.155 20.246C97.789 112.86 99.099 113.479 99.857 113.479",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.2,
    stroke: "none"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2978",
    d: "M51.396 214.38c-15.723-25.105-21.321-14.91-17.672-42.457 -5.209-9.411-9.375-18.77-12.191-28.824 -5.598-21.481 0.132-35.265 5.142-50.948C21.889 26.813 59.341-9.001 100.71-9.001c32.28 0 67.16 23.47 67.471 75.221 -0.514 9.459-1.932 25.343-3.003 32.165 17.769 55.029 2.501 50.649-11.07 76.357 -3.681 6.968-8.012 17.267-8.919 27.573 -18.66-33.246-16.96-38.325-10.676-53.39 7.504-17.985 4.547-4.07-10.03-2.422 13.563-10.49 22.717-10.462 23.003-75.823 0.001-0.039-0.021-0.075-0.054-0.091 -12.352-5.881-24.037-17.006-31.256-29.76 -0.018-0.031-0.047-0.05-0.082-0.05 -0.001 0-0.003 0-0.003 0 -0.037 0.001-0.07 0.023-0.085 0.057 -8.335 17.787-22.626 27.374-46.336 31.084 -4.629 2.417-9.738 4.666-16.104 7.085 -0.037 0.014-0.063 0.051-0.063 0.092 -0.428 25.658 5.466 43.881 20.327 65.193 -7.085-3.254-12.746-12.711-12.746-12.711 -0.355 0 2.484 4.965 2.662 5.281C83.555 172.154 51.627 183.483 51.396 214.38z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2979",
    d: "M50.101 212.286c-16.177-25.105-21.937-14.91-18.182-42.457 -5.36-9.411-9.647-18.77-12.543-28.824 -5.76-21.481 0.135-35.265 5.29-50.948C19.741 24.72 58.275-11.095 100.841-11.095c33.21 0 69.099 23.47 69.419 75.221 -0.527 9.459-1.984 25.343-3.089 32.165 18.283 55.029 2.573 50.649-11.39 76.357 -3.789 6.968-8.242 17.267-9.175 27.573 -19.202-33.246-17.451-38.325-10.984-53.39 7.718-17.985 2.953-4.116-10.321-1.223 13.954-10.49 23.373-11.661 23.668-77.022 0.001-0.039-0.022-0.075-0.058-0.091 -12.709-5.881-24.729-17.006-32.156-29.76 -0.018-0.031-0.051-0.05-0.086-0.05 -0.001 0-0.003 0-0.004 0 -0.037 0.001-0.07 0.023-0.086 0.057 -8.577 17.787-23.281 27.374-47.675 31.084 -4.764 2.417-10.02 4.666-16.569 7.085 -0.039 0.014-0.064 0.051-0.065 0.092 -0.441 25.657 5.624 44.881 20.914 66.193 -7.322-5.419-13.113-13.711-13.113-13.711 -0.366 0 2.556 4.965 2.738 5.281C83.189 170.061 50.338 181.39 50.101 212.286z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2980",
    d: "M27.34 109.853c-0.751-7.729-12.676-57.451 16.781-93.862C30.129 43.148 26.056 79.801 27.34 109.853zM167.521 94.041c4.414-30.432 5.609-63.063-19.443-86.74C160.453 31.492 169.091 49.191 167.521 94.041zM143.14 22.856c-2.382 11.089 1.711 25.652 3.052 35.713C139.202 52.934 135.036 45 130.23 33.973c1.055 6.228 3.485 17.428 16.972 31.263 -21.798-19.468-26.475-29.291-22.914-52.455 -0.198 0.877-0.389 1.705-0.573 2.49C124.192 12.729 124.628 9.983 125 7c-3.201 18-27.117 50.049-47.061 56.902 -3.01 3.013-5.737 3.154-8.993 5.917 27.231-4.152 44.396-19.706 48.078-30.866 7.436 12.238 20.931 23.546 33.167 29.331C152.039 52.092 146.191 42.142 143.14 22.856zM101.536 23.569c-9 15-14.354 24.5-28.354 33.5 4.545-3.637 7.687-9.667 9.531-14.927C77.203 50.297 68.565 55.381 61 62c7.516-8.268 17.645-19.858 24.036-30.931 -6.442 8.582-16.813 15.337-26.036 23 7.256-6.029 13-13.667 17-21.667 -2.775 3.7-7.862 6.459-14 12.598 8.972-11.966 9.88-17.484 12.419-22.405 -6.216 10.474-11.655 14.106-17.794 19.295 -4.221 17.702-4.461 25.388-5.256 35.113 -0.039 0.469 17.113-6.963 17.535-7.177 0.014-0.002 0.028-0.005 0.042-0.007C84.938 56.249 91.502 42.094 101.536 23.569zM60 137c2.788 11.151 1.226 21.095-2.464 32.735 -0.488-10.761-8.475-21.806-14.417-31.462 1.364 20.726 3.566 30.364 0.083 46.129 -1.866-28.597-7.833-38.269-16.583-59.417 -3.527 13.393-2.659 30.866 5.299 44.844 -3.755 27.547 2.005 17.352 18.182 42.457 0.238-30.896 33.088-42.226 12.707-77.52 -0.183-0.316-3.104-5.281-2.738-5.281 0 0 5.792 8.292 13.113 13.711 -22.233-24.211-28.063-54.711-28.7-87.711C39.495 95.233 54 117 60 137zM169.126 101.456c0.865 16.928 5.439 38.169-9.257 51.947 6-10 3.131-23.403 0.131-33.403 0.376 26.762-10.812 42.834-13.809 60.402 -0.456-8.086-2.304-17.859 1.473-31.015 -3.663 6.402-7.795 13.848-9.388 22.723 -5.241-9.827-2.367-17.266-0.533-26.834 7.778-8.19 13.157-23.839 14.294-33.894 -0.935 8.266-6.287 20.703-12.478 25.897 -0.001 0.009-0.536 1.809-1.124 3.782 0.044-0.333 0.086-0.668 0.125-1.008 -8.928 21.01-13.345 23.131 8.046 60.166 0.845-9.357 4.724-19.388 9.175-27.573C169.236 147.874 184.401 150.477 169.126 101.456z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2981",
    d: "M155.339 79.777c4.269-17.414-2.295-44.215-5.664-49.444C154.928 38.481 161.974 60.465 155.339 79.777zM159.441 87.699c0.458-2.363 14.095-28.735-8.994-65.914C171.332 59.802 159.905 85.303 159.441 87.699zM34.086 55.382c1-0.447 7.361-47.259 48.429-56.088C39.446 6.883 35.086 54.937 34.086 55.382zM39.756 99.767c-0.024-1.003-8.152-47.383 14.691-77.104C27.996 53.967 39.732 98.767 39.756 99.767zM43.013 131.156c-1.428-1.897-13.106-33.317-7.671-69.134C25.286 99.584 42.261 130.156 43.013 131.156zM153.395 30.807c-1-0.295-13.057-35.017-37.847-31.593C137.232-2.015 152.395 30.509 153.395 30.807zM132.763 48.797c0 0-9.419-14.771-6.004-39.082C123.607 24.555 123.938 34.813 132.763 48.797zM135.424 37.302c2.568 7.16 8.104 14.888 9.026 15.499 -1.001-0.663-9.66-13.341-11.684-34.227C132.946 24.843 133.284 31.334 135.424 37.302zM88.142 57.415c7.993-7.77 25.836-15.403 35.973-52.374C113.238 39.193 96.597 49.196 88.142 57.415zM88.167 27.009c6.991-6.677 9.494-13.522 9.407-19.946C96.858 13.51 93.367 22.043 88.167 27.009zM78.146 30.338c0.377-0.013 1.333-1.137 1.603-1.373 7.977-6.959 11.625-12.581 12.388-22.236C90.966 17.738 79.148 30.304 78.146 30.338zM76.803 28.359c0 0 8.23-9.662 11.186-23.308C84.859 15.938 76.803 28.359 76.803 28.359zM56.403 153.735c0.581-1 1.925-20.274-7.62-28.24C54.788 131.589 56.983 152.734 56.403 153.735zM56.42 153.725c-0.46-7.765-7.55-13.918-8.99-23.647C47.966 142.486 55.625 146.906 56.42 153.725zM41.095 160.402c-0.959-2.241 3.723-12.528-10.313-34.283C42.215 146.698 40.633 159.322 41.095 160.402zM41.115 159.081c-1.186-4.379 0.906-13.748-4.325-28.989C39.524 140.203 39.581 153.409 41.115 159.081zM150.024 131.289c-4.108 8.074-12.523 13.667-10.338 33.775 -0.201-1.853 0.16-3.941 0.305-5.79 1.957-24.953 8.672-5.729 16.046-52.242C154.253 114.17 152.895 125.648 150.024 131.289zM147.729 167.729c0.371-1.456 0.345-3.097 0.603-4.586 2.182-12.614 6.991-19.381 7.411-39.744C154.781 139.88 147.521 153.505 147.729 167.729zM165.107 141.027c0.469-3.128 6.825-7.942 1.996-32.945C169.849 133.741 165.568 137.951 165.107 141.027zM165.108 141.058c0.438-1 3.109-17.928-3.651-30.616C166.176 120.715 165.547 140.058 165.108 141.058z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2982",
    d: "M18.901 151.753c0.248-2.574 0.649-5.177 1.238-7.817 2.5 7.838 5.503 15.074 11.68 25.88 -3.773 27.679 2.116 17.422 18.38 42.81 0-22.267 17.058-34.558 19.03-51.87 1.784-15.764-4.759-22.359-9.16-31.17 3.666 5.108 8.469 10.416 13.56 14.061 -14.507-20.062-21.735-38.961-21.26-66.64 5.63-2.08 11.2-4.36 16.55-7.08 21.469-3.266 38.274-11.49 47.75-31.14 7.314 12.562 19.169 23.77 32.2 29.8 -0.298 65.876-9.77 66.413-23.98 77.209 5.811-1.109 12.751-5.729 14.311-7.93 -9.068 23.75-15.193 23.472 7.479 62.68 0.796-9.556 4.586-19.383 9.19-27.85 13.917-25.626 29.741-22.284 11.45-77.29 1.544-9.539 2.827-18.686 3-27.83 0.175 3.245 0.276 6.377 0.367 9.425 0.214 0 0.428 0 0.641 0 -0.257-4.086-0.525-8.347-0.968-12.875 -0.657-106.408-155.465-102.179-145.79 25.9 -5.227 15.913-11.063 29.484-5.29 50.95 -0.926 3.002-1.626 5.909-2.137 8.749C17.674 150.456 18.233 151.159 18.901 151.753zM24.959 94.285c0.095 1 3.72 27.654 1.32 8.13C8.536-41.931 192.536-51.931 166.139 101.896c-1.794 10.454-0.768 5.549 0.961-5.12 17.259 58.25-3.75 45.563-18.32 87.37 -1.37 3.939-2.34 9-2.74 13.13 -21.623-38.089-11.207-41.533-5.64-60.7 6.599-7.292 10.615-15.871 11.71-26.52 -2.591 17.989-14.384 30.05-24.181 34.06 5.116-3.371 10.438-6.975 13.601-12.39 2.034-2.136 11.762-26.173 8.12-72.03 -1.673-20.141-8.437-26.107-6.931-34.66 -1.396 6.717 2.429 11.257 4.71 25.08 1.055 6.458 1.431 15.847 1.431 17.57 -10.923-5.965-24.91-18.89-31.76-29.79 4.461-9.145 6.782-23.075 8.6-31.87 -5.416 22.088-9.213 52.515-53.76 62.3 7.232-3.953 22.987-12.243 39.25-45.36 0.02-0.01 0.029-0.02 0.029-0.04 8.711-17.095 0.602-2.034-0.09-0.8 -0.013-0.026-0.01-0.103-0.01 0.01 -20.156 36.093-36.387 45.333-58.75 54.6 0.01-0.68 0.02-1.36 0.05-2.04 27.481-8.941 44.618-41.674 39.07-33.58 -8.877 13.02-24.155 28.015-39.06 33.34 0.017-1 0.183-4.32 0.46-7.14 19.215-13.644 23.448-20.838 30.89-33.8 0.556-0.979 1.037-1.813 1.454-2.526C80.75 37.814 68.93 54.19 52.939 66.715c0.44-4.62 1.1-9.22 1.89-13.79 0.921-1.218 8.834-7.552 15.32-20.74 3.094-6.249 4.27-9.59 4.27-9.59 -0.871 1.578-6.035 13.404-19.31 28.78 2.19-12.138 5.188-23.076 8.57-35.03 -5.756 17.895-11.357 37.272-13.01 56.8 -0.488 1-1.416 37.987 17.235 63.969 -28.77-30.95-24.066-68.987-23.885-81.719 -0.09 0-0.75 10.35-0.8 11.05 -3.867 51.415 25.597 63.853 24 90.61 -1.172 19.548-17.347 30.422-17.49 53.89 -12.637-21.956-19.809-15.55-16.85-39.3 0.077-1 1.134-8.253 0.08-15.33 -1.696-11.256-4.121-14.498-3.766-16.86 -0.269 1.428 0.351 2.886 1.417 6.7 1.909 6.668 2.163 15.704 1.33 22.73C15.417 136.337 17.729 119.042 24.959 94.285z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2899",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#26120b",
    strokeWidth: "none",
    opacity: 1
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect1052",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "SvgjsText1053",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "10px",
    textAnchor: "start",
    fontWeight: 400,
    anchor: "start",
    fill: "#333333",
    x: 38.76297378540039,
    y: 182.42838287353516,
    style: {
      display: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan1054",
    dy: 13,
    x: 38.76297378540039
  }, "Created on svgAvatars.com")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAvatar);
export default __webpack_public_path__ + "static/media/myAvatar.bc2da4544d205dfa7d02a20064438c19.svg";
export { ForwardRef as ReactComponent };